import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '@mui/material';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import '../About.css';

const DigitalTransformation = () => {
  const services = [
    'Digital Strategy & Roadmap Development',
    'Legacy System Modernization',
    'Process Automation & Optimization',
    'Change Management & Training'
  ];

  return (
    <div className="about-page">
      <section className="about-hero">
        <div className="container">
          <h1>Digital Transformation</h1>
          <p>
            Modernize operations, improve efficiency, and drive innovation through 
            comprehensive digital transformation initiatives.
          </p>
        </div>
      </section>

      <section className="about-story">
        <div className="container">
          <div className="story-content">
            <h2>Overview</h2>
            <p>
              Digital transformation is more than technology adoption—it's a fundamental shift in 
              how organizations operate and deliver value. We help enterprises modernize legacy 
              systems, automate processes, and leverage data to make informed decisions.
            </p>
            <p>
              Our approach combines strategic planning with pragmatic execution, ensuring your 
              transformation delivers measurable business outcomes while minimizing disruption 
              to ongoing operations.
            </p>
          </div>
        </div>
      </section>

      <section className="about-expertise">
        <div className="container">
          <div className="section-header">
            <h2>Transformation Services</h2>
            <p>End-to-end capabilities for digital modernization</p>
          </div>
          <div className="expertise-grid">
            {services.map((service, index) => (
              <div key={index} className="expertise-item">
                {service}
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="about-cta">
        <div className="container">
          <div className="cta-content">
            <h2>Start Your Digital Transformation</h2>
            <p>Schedule a consultation to discuss your modernization goals and requirements.</p>
            <Link to="/contact">
              <Button 
                variant="contained"
                size="large"
                endIcon={<ArrowForwardIcon />}
                sx={{
                  backgroundColor: '#2271b1',
                  color: '#ffffff',
                  fontWeight: '600',
                  padding: '14px 32px',
                  fontSize: '15px',
                  textTransform: 'none',
                  borderRadius: '3px',
                  boxShadow: '0 1px 0 #135e96',
                  transition: 'all 0.2s',
                  '&:hover': {
                    backgroundColor: '#135e96',
                    transform: 'translateY(-1px)',
                    boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
                  }
                }}
              >
                Contact Us
              </Button>
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default DigitalTransformation;
